import { SnackbarOrigin } from "@material-ui/core/Snackbar";
import { withSnackbar, WithSnackbarProps } from "notistack";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ApplicationState } from "../..";
import { actionCreators, NotificationsState } from "../../store/notifications/NotificationStore";
import { isTranslationKey, TranslationKey } from "../../translations/TranslationKey";
import TranslatedMessage from "../translations/TranslatedMessage";

type NotificationsProps = NotificationsState & typeof actionCreators & WithSnackbarProps;

const defaultAnchorOrigin: SnackbarOrigin = { horizontal: "center", vertical: "top" };
const tenSecondsInMs = 10000;

class Notifications extends React.Component<NotificationsProps> {
  public componentDidUpdate = () => {
    this.displayNewErrors();
  };

  public render() {
    return [];
  }

  private displayNewErrors = () => {
    const { enqueueSnackbar } = this.props;
    const newErrors = this.props.errors;

    newErrors.forEach(({ error, data }) => {
      this.props.removeNotifications([error]);
      const message = isTranslationKey(error) ? (
        <TranslatedMessage id={error as TranslationKey} values={data} />
      ) : (
        error
      );
      enqueueSnackbar(message, {
        anchorOrigin: defaultAnchorOrigin,
        autoHideDuration: tenSecondsInMs,
        variant: "error",
        preventDuplicate: true,
        key: error,
      });
    });
  };
}

const notificationsWithSnackbar = withSnackbar(Notifications);

const mapStateToProps = (state: ApplicationState) => state.notificationsState;
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ ...actionCreators }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(notificationsWithSnackbar);
